document.querySelectorAll('.fn_adverts_slide_edit').forEach(function (element) {
	let slide = element.nextElementSibling;
	if (slide) {
		slide.appendChild(element);
	}
})